












import { Vue, Prop, Watch } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';

import mixin from '@/mixins/cookie';
import formatter from '@/mixins/formatter';

@Component
export default class Number extends mixins(mixin, formatter) {
  @Prop() payload!: { [key: string]: string };
  @Prop({ default: '' }) id?: string;
  @Prop({ default: '' }) validateRules?: string;
  @Prop({ default: '' }) name?: string;
  @Prop({ default: 0 }) count!: number;

  mounted() {
    const input = this.$refs.input as HTMLInputElement;
    setTimeout(() => (input.value = this.$props.count), 100);
  }

  get inputValue() {
    return this.$props.count;
  }

  set inputValue(val: string) {
    const v = this.convertToValidValue(val);
    this.$emit('update', v);
  }

  get inputId(): string {
    return this.id !== '' && this.id !== undefined
      ? this.id
      : Object.values(this.payload).join('-');
  }

  get inputName(): string {
    return this.name !== '' && this.name !== undefined
      ? this.name
      : Object.values(this.payload).join('-');
  }

  private handleBlur(event: Event): void {
    if (event.target instanceof HTMLInputElement) {
      const elem = event.target;
      const v = this.convertToValidValue(elem.value);
      elem.value = v;
    }
  }
}
